import * as types from "../types/snackbar_type";

const showSnackBar =
  (params = {}) =>
  async (dispatch) => {
    return dispatch({
      type: types.SHOW_SNACKBAR,
      snackBarMessage: params.message,
      severity: params.severity,
      isMoreThan2MB: params.isMoreThan2MB,
      accountCreated: params.accountCreated,
      customSeverityText: params.customSeverityText,
      key: new Date().getTime(),
      showActionButton: params.showActionButton,
    });
  };

const hideSnackBar = () => async (dispatch) => {
  return new Promise((resolve) => {
    return resolve(
      dispatch({
        type: types.HIDE_SNACKBAR,
      })
    );
  });
};

export { hideSnackBar, showSnackBar };
